/* GD House — socle Bambuser (27/07/2026).
   Centralise les appels à l'API publique des widgets Live Shopping (CORS ouvert au domaine
   boutique) + le binding du player SDK (initBambuserLiveShopping, chargé par le custom-liquid
   du header). Cache sessionStorage 5 min pour ménager l'API.
   Consommé par : gd-announce (compteur next live), gd-hero (chip), gd-replays, et à venir
   « pièces du dernier live » / badge « vu en live » PDP. */
window.GDBambuser = window.GDBambuser || (function () {
  var BASE = 'https://svc-prod-eu.liveshopping.bambuser.com/widgets';
  var TTL = 5 * 60 * 1000;

  function fetchJSON(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('GDBambuser: HTTP ' + r.status + ' — ' + url);
      return r.json();
    });
  }

  function cached(key, fn) {
    try {
      var raw = sessionStorage.getItem(key);
      if (raw) {
        var o = JSON.parse(raw);
        if (Date.now() - o.t < TTL) return Promise.resolve(o.d);
      }
    } catch (e) {}
    return fn().then(function (d) {
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
      return d;
    });
  }

  function channel(channelId) {
    return cached('gdbam:ch:' + channelId, function () {
      return fetchJSON(BASE + '/channels/' + encodeURIComponent(channelId));
    });
  }

  /* Shim officiel du player : l'embed du header est la variante « widget
     flottant » (__bfwId) qui n'expose PAS initBambuserLiveShopping (constate
     01/08 : jamais defini sur la home) → on charge nous-memes embed.js, la
     file d'attente etant consommee a son arrivee. En cas d'echec du script,
     on annule le shim pour que les fallbacks href reprennent la main. */
  function shim() {
    if (window.initBambuserLiveShopping) return;
    var q = function (item) { q.queue.push(item); };
    q.queue = [];
    window.initBambuserLiveShopping = q;
    var sc = document.createElement('script');
    sc.src = 'https://lcx-embed-eu.bambuser.com/default/embed.js';
    sc.onerror = function () { window.initBambuserLiveShopping = null; };
    document.body.appendChild(sc);
  }

  return {
    channel: channel,

    /* Show actuellement EN DIRECT, ou null. Le live en cours arrive dans `featured`
       (constaté sur le payload channel le 01/08, show isLive hors playlists) ;
       on scanne aussi les playlists par prudence. Latence max = TTL du cache (5 min). */
    liveShow: function (channelId) {
      return channel(channelId).then(function (d) {
        if (d.featured && d.featured.isLive) return d.featured;
        var shows = [];
        (d.playlists || []).forEach(function (p) { shows = shows.concat(p.shows || []); });
        return shows.filter(function (s) { return s && s.isLive && !s.isArchived; })[0] || null;
      });
    },

    /* Shows à venir (playlist "scheduled") tries par date, live en cours en tête.
       Sert au calendrier de la page d'accueil (carte Notion, 29/08/2026). */
    upcomingShows: function (channelId, max) {
      return channel(channelId).then(function (d) {
        var upcoming = [];
        var live = null;
        if (d.featured && d.featured.isLive) live = d.featured;
        (d.playlists || []).forEach(function (p) {
          (p.shows || []).forEach(function (s) {
            if (s.isLive && !s.isArchived && !live) live = s;
            else if (p.type === 'scheduled' && s.scheduledStartAt && s.scheduledStartAt > Date.now()) upcoming.push(s);
          });
        });
        upcoming.sort(function (a, b) { return a.scheduledStartAt - b.scheduledStartAt; });
        if (live) upcoming.unshift(live);
        return upcoming.slice(0, max || 4);
      });
    },

    /* Prochain show programmé (playlist "scheduled"), ou null. */
    nextShow: function (channelId) {
      return channel(channelId).then(function (d) {
        var shows = [];
        (d.playlists || []).forEach(function (p) {
          if (p.type === 'scheduled') shows = shows.concat(p.shows || []);
        });
        shows = shows
          .filter(function (s) { return s.scheduledStartAt && s.scheduledStartAt > Date.now(); })
          .sort(function (a, b) { return a.scheduledStartAt - b.scheduledStartAt; });
        return shows[0] || null;
      });
    },

    /* Replays publiés (playlist "archived"), du plus récent au plus ancien. */
    replays: function (channelId) {
      return channel(channelId).then(function (d) {
        var shows = [];
        (d.playlists || []).forEach(function (p) {
          if (p.type === 'archived') shows = shows.concat(p.shows || []);
        });
        return shows.filter(function (s) { return s.published && s.isArchived; });
      });
    },

    /* Produits présentés dans un show : { publicUrl (URL Shopify), productReference (ID),
       title, thumbnail, price… } */
    showProducts: function (showId) {
      return cached('gdbam:pr:' + showId, function () {
        return fetchJSON(BASE + '/shows/' + encodeURIComponent(showId) + '/products')
          .then(function (d) { return d.products || []; });
      });
    },

    /* Enregistre `node` comme declencheur du player officiel. ATTENTION : le
       clic qui ouvre le player est le clic SUIVANT cet appel — a n'utiliser
       qu'au chargement de la page, jamais depuis un gestionnaire de clic.
       Pour ce cas-la, voir openPlayer. */
    /* `deeplink` (optionnel) ouvre le replay a l'instant ou la piece est
       presentee. Format Bambuser : "<hashId>@<secondes>", fourni par
       /products/highlighted/shows/by-references et recopie dans le
       metachamp `custom.live_replay`. */
    bindPlayer: function (node, showId, deeplink) {
      shim();
      var options = { showId: showId, node: node, type: 'overlay' };
      if (deeplink) { options.deeplink = deeplink; }
      window.initBambuserLiveShopping(options);
    },

    /* Ouvre le replay TOUT DE SUITE, sans passer par un noeud declencheur.
       Difference avec bindPlayer, et raison d'etre de cette methode : avec
       l'option `node`, Bambuser ne fait qu'ENREGISTRER l'element comme
       declencheur — c'est le clic SUIVANT qui ouvre le player. Appelee depuis
       un gestionnaire de clic, elle mange donc le premier clic (constate sur
       la fiche produit le 27/08 : il fallait cliquer deux fois). La doc est
       explicite : « Omitting the node property [...] will trigger the
       initialized show immediately ».
       gd-replays / gd-hero / gd-announce enregistrent au chargement de la
       page, jamais dans le clic : pour eux `bindPlayer` reste correct. */
    openPlayer: function (showId, deeplink) {
      shim();
      var options = { showId: showId, type: 'overlay' };
      if (deeplink) { options.deeplink = deeplink; }
      window.initBambuserLiveShopping(options);
    },

    /* Compte à rebours vers `targetMs`. Appelle render({d,h,m,s}) chaque seconde,
       puis onEnd() à échéance. Retourne un handle {stop}. */
    countdown: function (targetMs, render, onEnd) {
      function tick() {
        var left = targetMs - Date.now();
        if (left <= 0) { clearInterval(iv); if (onEnd) onEnd(); return; }
        var s = Math.floor(left / 1000);
        render({ d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 });
      }
      var iv = setInterval(tick, 1000);
      tick();
      return { stop: function () { clearInterval(iv); } };
    }
  };
})();
